import { Store } from '../general'

class Firmware extends Store {
  async init() {}
}

export default Firmware
